module.exports = __webpack_public_path__ + "static/media/screen2.bb29ba40.jpg";